define('viewmodels/modals/dialogs/QuestLeaderboardDialog',['knockout'], function (ko) {

    var QuestLeaderboardDialog = function(dialog, leaderboards, quests, content) {
        var self = this;
        self.dialog = dialog;
        self.quests = quests;
        self.content = content;
        self.selectedQuest = ko.observable().withFallback(ko.pureComputed(function() { return self.quests()[0]; }));

        self.selectQuest = function(quest) {
            if (self.selectedQuest() === quest) {
                return;
            }
            self.selectedQuest(quest);
        };

        self.leaderboardEntries = function(quest) {
            return leaderboards.getEntriesById(quest);
        };
    };

    QuestLeaderboardDialog.prototype.close = function() {
        this.dialog.close(this);
    };

    return QuestLeaderboardDialog;
});

